module.exports = __webpack_public_path__ + "img/heilongjiang.e5b4eceb.jpg";